module.exports = __webpack_public_path__ + "img/img_fuwu.c2cf73d9.png";